<div class="ai-field-shell">
  <!-- Toolbar and field share a positioning anchor of their own so the Adjust
       bar below can never move either of them: the toolbar is absolutely placed
       against this box (above the field at full density, docked inside it when
       compact), and the bar sits outside it. -->
  <div class="ai-field-anchor">
  <div class="ai-field-toolbar-row" [class.ai-field-toolbar-row--compact]="density === 'compact'" *ngIf="showToolbar">
    <button type="button" class="ai-field-trigger" *ngIf="showAiTrigger"
      tooltip="{{ 'AI writing tools' | translate }}" placement="top"
      title="{{ 'AI writing tools' | translate }}"
      (mousedown)="$event.preventDefault()" (click)="toggleAiTools()"
      [attr.aria-label]="'AI writing tools' | translate">
      <svg class="ai-field-trigger-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="aiTrigger{{historyKey}}" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#FE4649"/>
            <stop offset="0.4" stop-color="#CD5CC2"/>
            <stop offset="0.7" stop-color="#8B68EF"/>
            <stop offset="1" stop-color="#3E96FE"/>
          </linearGradient>
        </defs>
        <path d="M10 2.5l1.7 4.3 4.3 1.7-4.3 1.7L10 14.5l-1.7-4.3L4 8.5l4.3-1.7L10 2.5z" [attr.fill]="'url(#aiTrigger' + historyKey + ')'"/>
        <path d="M15.5 13l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7.7-1.8z" [attr.fill]="'url(#aiTrigger' + historyKey + ')'"/>
      </svg>
    </button>
    <app-ai-writing-toolbar
      *ngIf="(hasText && showAiActions) || hasHistory"
      [proofreading]="proofreadLoading"
      [rewriting]="rewriteLoading"
      [adjusting]="adjustLoading"
      [adjustOpen]="adjustOpen"
      [hasText]="hasText && showAiActions"
      [hasHistory]="hasHistory"
      [canUndo]="canUndo"
      [canRedo]="canRedo"
      [density]="density"
      (proofread)="onProofread()"
      (rewrite)="onRewrite()"
      (adjust)="onAdjust()"
      (undo)="onUndo()"
      (redo)="onRedo()"
      (history)="onOpenHistory()">
    </app-ai-writing-toolbar>
  </div>

  <div class="ai-field-ring-wrap" [class.ai-field-loading]="aiEnabled && isBusy">
    <div class="ai-field-inner">
      <!-- No <ion-item> wrapper: several call sites already sit inside one,
           and nested ion-items aren't supported by Ionic. The field styles
           itself via the --ai-field-* passthrough instead.
           Bound via ngModel (standalone, so it never registers with a parent
           form) rather than [value]+(ionInput): on Ionic 6 ionInput emits the
           native InputEvent, so $event.detail.value is undefined and every
           keystroke would write an empty string back into the model. -->
      <ion-textarea #fieldEl *ngIf="multiline"
        class="ai-field-control"
        [class.ai-field-control--compact]="density === 'compact'"
        [class.ai-field-hidden]="aiEnabled && showVeil"
        [class.ai-field-revealing]="revealing"
        [ngModel]="value"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onInput($event)"
        [readonly]="isReadonly"
        [disabled]="disabledState"
        [rows]="rows"
        [maxlength]="maxlength"
        [placeholder]="placeholder"
        (ionFocus)="onFocus()"
        (ionBlur)="onBlur()">
      </ion-textarea>
      <ion-input #fieldEl *ngIf="!multiline"
        class="ai-field-control"
        [class.ai-field-control--compact]="density === 'compact'"
        [class.ai-field-hidden]="aiEnabled && showVeil"
        [class.ai-field-revealing]="revealing"
        [ngModel]="value"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onInput($event)"
        [readonly]="isReadonly"
        [disabled]="disabledState"
        [maxlength]="maxlength"
        [placeholder]="placeholder"
        (ionFocus)="onFocus()"
        (ionBlur)="onBlur()">
      </ion-input>
      <div class="ai-field-veil" *ngIf="aiEnabled && showVeil">
        <span class="ai-field-veil-text">{{ loadingPhrase }}</span>
      </div>
    </div>
  </div>
  </div>

  <!-- Adjust bar. Expands in place below the field, so the sentence being
       steered never leaves the screen. Shared with the roadmap step fields,
       which cannot use this shell at all — see ai-adjust-bar for why. -->
  <app-ai-adjust-bar *ngIf="showToolbar && adjustOpen"
    [loading]="adjustLoading"
    [canUndo]="canUndo"
    [error]="adjustError"
    [applied]="applied"
    [appliedSkillId]="appliedSkillId"
    (apply)="onAdjustApply($event)"
    (undo)="onUndo()"
    (dismiss)="closeAdjust()"
    (resultSuperseded)="clearResult()">
  </app-ai-adjust-bar>

</div>
